import React, { Component } from "react";
import { connect } from "react-redux";
import { hashHistory, withRouter } from "react-router";
import Util from "../../util.js";
import NavigatorMain from "../NavigatorMain";
import NHeader from "../NHeader.js";
import Performance from "../Performance.js";
import "./portfolioPerformance.css";
import InfoTable from "../InfoTable.js";
import LineEchartPerformanceTrends from "../LineEchartPerformanceTrends.js";
import {  getSuperFundProductIncome, superFundProductIncomeDelAction, LineDataDelAction, lineDataLastDel } from "../../action/portfolioAction";

class PortfolioPerformance extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    document.title= "组合表现";
    let { dispatch, location } = this.props;
    const params = {
      superFundCode: location.state.superFundCode,
      periodType: 1,
    };
    dispatch(getSuperFundProductIncome(params));
  }
  componentWillUnmount() {}
  goBack = () => {
    hashHistory.goBack();
  };

  getInfo = (infos = {}) => {
    const formatter = (value) => {
      if (value == 0) return "0.00";
      if (!value) return "--";
      const _value = value;

      const result = (Math.floor(Math.abs(value) * 100) / 100).toFixed(2);
      const flag = result != 0 ? (_value < 0 ? "-" : "") : "";
      return `${flag}${result}`;
    };
    let day='--'
    if (infos.navActualDate) {
      const date = new Date(infos.navActualDate);
       day = `${date.getMonth() + 1}.${date.getDate()}`;
    }

    return {
      incomeRateList: [
        [
          [Util.toPercent(infos.dayGains), `日涨跌幅 (${day})`],
          [Util.toPercent(infos.hisAnnualizedGains), "成立以来年化"],
          [Util.toPercent(infos.gains), "成立以来涨跌幅"],
        ],
        [
          [Util.toPercent(infos.monthGains), "近一月涨跌幅"],
          [Util.toPercent(infos.month3Gains), "近三月涨跌幅"],
          [Util.toPercent(infos.month6Gains), "近六月涨跌幅"],
        ],
        [
          [Util.toPercent(infos.yearGains), "近一年涨跌幅"],
          [Util.toPercent(infos.thisYearGains), "今年以来涨跌幅"],
        ],
      ],
      riskIndex: [
        [
          [Util.toPercent(infos.hisMaxRetreat), "组合最大回撤"],
          [Util.toPercent(infos.maxRetreat), "近一年最大回撤"],
        ],
        [
          [Util.toPercent(infos.hisAnnualizedVolatility), "年化波动率"],
          [formatter(infos.hisSharpeRate), "夏普比率"],
        ],
      ],
    };
  };
  render() {
    return (
      <div className="container PPF_container">
        <NavigatorMain>
          <NHeader title="组合表现" isPaddingBottom={0}/>
        </NavigatorMain>
        <div className="PPF_content">
          <Performance title="业绩表现" background={true} style={{borderRadius:'.2rem .2rem 0 0',marginBottom:'.2rem'}} renderDOM={<InfoTable  cols={3} dataSouse={this.getInfo(this.props).incomeRateList} valueStyle={{fontSize:'.32rem'}}/>} />
          <Performance title="业绩走势" style={{marginBottom:'.2rem'}} renderDOM={<LineEchartPerformanceTrends />} />
          <Performance
            title="风险指标"
            renderDOM={
              <div style={{ margin: "0 -.3rem" }}>
                <InfoTable cols={2} dataSouse={this.getInfo(this.props).riskIndex} valueStyle={{fontSize:'.32rem'}}/>
              </div>
            }
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    ...state.superFundProductIncomes,
  };
}
export default withRouter(connect(mapStateToProps)(PortfolioPerformance));



// WEBPACK FOOTER //
// ./src/components/fundDetail/PortfolioPerformance.js